import { MONTHS } from 'features/advance/constants/constants';
import { z } from 'zod';

const memoizeDateErrors = (() => {
  const cache = new Map<string, string>();

  return (minDate: Date, maxDate: Date) => {
    const maxDateKey = maxDate.toISOString();
    const minDateKey = minDate.toISOString();

    if (!cache.has(maxDateKey)) {
      const maxDateErrorMonth = (MONTHS as string[])[maxDate.getMonth()];
      const maxDateErrorYear = maxDate.getFullYear();
      const maxDateErrorDay = maxDate.getDate();
      const maxDateError = `Please pick a day on or before ${maxDateErrorMonth} ${maxDateErrorDay}, ${maxDateErrorYear}`;
      cache.set(maxDateKey, maxDateError);
    }

    if (!cache.has(minDateKey)) {
      const minDateErrorMonth = (MONTHS as string[])[minDate.getMonth()];
      const minDateErrorYear = minDate.getFullYear();
      const minDateErrorDay = minDate.getDate();
      const minDateError = `Please pick a day on or after ${minDateErrorMonth} ${minDateErrorDay}, ${minDateErrorYear}`;
      cache.set(minDateKey, minDateError);
    }

    return {
      maxDateError: cache.get(maxDateKey)!,
      minDateError: cache.get(minDateKey)!,
    };
  };
})();

export const autoPaymentDateSchema = (
  minDate: Date,
  maxDate: Date,
  validDates?: string[],
  validateDateReasoning?: string,
) => {
  const { maxDateError, minDateError } = memoizeDateErrors(minDate, maxDate);

  return z
    .date({
      error: (issue) =>
        issue.input === undefined ? 'Required' : 'Please enter a valid date',
    })
    .min(minDate, { message: minDateError })
    .max(maxDate, { message: maxDateError })
    .refine((date) => {
      if (validDates) {
        const localDate = date.toLocaleDateString('en-US', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
        });

        const splitLocalDate = localDate.split('/');

        const reversedLocalDate = `${splitLocalDate[2]}-${splitLocalDate[0]}-${splitLocalDate[1]}`;

        return validDates.includes(reversedLocalDate);
      }

      return false;
    }, validateDateReasoning);
};
